import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core';
import { SettingsRoutingModule } from './settings-routing.module';
import { ClientsSettingsComponent } from './clients-settings/clients-settings.component';
import { ClientsActivationWidgetComponent } from './clients-settings/clients-activation-widget/clients-activation-widget.component';

@NgModule({
  imports: [CommonModule, CoreModule, SettingsRoutingModule],
  declarations: [ClientsSettingsComponent, ClientsActivationWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsModule {}
